import { connect } from 'react-redux';
import PropProvider from '../PropProvider';
import SelectInputSourceDialog from '../components/SelectInputSourceDialog';
import { defaultMapDispatchToProps } from '../utils/ConnectDefaults';

export default connect(
  state => PropProvider(state).SelectInputSourceDialog(),
  defaultMapDispatchToProps
)(SelectInputSourceDialog);
